import React from "react";
import Fade from "react-reveal";


 function Footer() {

  
  return (
    <footer>
      <div className="row">
        <Fade bottom>
          <div className="twelve columns">
            <ul className="social-links">
              <li>
                <a href="https://www.instagram.com/mighty__dev/">
                   <i className='fa fa-instagram'/>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/manoj-kumar-m-792081211/">
                   <i className='fa fa-linkedin'/>
                </a>
              </li>
              <li>
                <a href="https://github.com/mastromanoj1">
                   <i className='fa fa-github'/>
                </a>
              </li>
            </ul>

            <ul className="copyright">
              <li>&copy; Copyright 2023 Manoj Kumar</li>
              <li>
                Design by{" "}
                <a title="Styleshout" href="http://www.styleshout.com/">
                  Styleshout
                </a>
              </li>
            </ul>
          </div>
        </Fade>

        <div id="go-top">
          <a className="smoothscroll" title="Back to Top" href="#home">
            <i className="icon-up-open"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
